import "../../../../@vanilla-extract/webpack-plugin/vanilla.virtual.css?%7B%22fileName%22%3A%22..%2F..%2Fnode_modules%2F%40faire%2Fweb%2Fui%2FResponsiveContentV2%2FViewport.css.ts.vanilla.css%22%2C%22source%22%3A%22%23H4sIAAAAAAAAA72SSwrCMABE9znFLHWh5Gd%2FbnoTCSZgwMbSirZI7y50YyBa%2BpEuA8ObeUnywmirUJ8rYxyU09gU1u2eVt8vGeIoKZst8CLA%2FsTUQ8mW0f4IaFuXV9VmcDdnjgToSEfyQR6jXIZA9hvopcTUWtV8NOK5rXyBbMppWBvN12CUixAoR3kcRqUmj%2FNspextg9EpSyeNHvuHgiIpvhStZhT%2F%2B10HgF4qWesil895A67ofldrBAAA%22%7D"
export var DesktopAndAbove = '_1ava4y15';
export var DesktopOnly = '_1ava4y14';
export var MobileOnly = '_1ava4y10';
export var TabletAndAbove = '_1ava4y12';
export var TabletAndBelow = '_1ava4y13';
export var TabletOnly = '_1ava4y11';
export var XLargeAndAbove = '_1ava4y18';
export var XLargeOnly = '_1ava4y16';
export var XXLargeOnly = '_1ava4y17';